import { ExclamationCircleIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

export const ResourceError = (props) => {
  const { errors, onRetry, retryLabel, subtitle } = props;
  const navigate = useNavigate();

  const errorMessages = errors 
    ? (Array.isArray(errors) ? errors : [errors])
    : ["Noe gikk galt, kunne ikke laste inn ønsket data"];

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      // Default: reload the page
      window.location.reload();
    }
  };

  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <div className="bg-white rounded-lg border-2 border-red-200 shadow-lg overflow-hidden">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-red-50 to-red-100 px-6 py-5 border-b border-red-200">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                <ExclamationCircleIcon className="h-8 w-8 text-red-600" />
              </div>
            </div>
            <div className="ml-4 flex-1">
              <h3 className="text-xl font-semibold text-red-900">
                {errorMessages.length === 1 ? "En feil oppstod" : `${errorMessages.length} feil oppstod`}
              </h3>
              <p className="mt-1 text-sm text-red-700">
                {subtitle || "Det oppstod en feil ved lasting av data. Se detaljer nedenfor."}
              </p>
            </div>
          </div>
        </div>

        {/* Error Details Section */}
        <div className="px-6 py-6">
          <div className="mb-6">
            <h4 className="text-sm font-medium text-gray-900 mb-3">Feilmeldinger:</h4>
            <ul className="space-y-2">
              {errorMessages.map((error, index) => (
                <li key={index} className="flex items-start">
                  <span className="flex-shrink-0 mt-1 mr-2">
                    <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-red-100 text-red-600 text-xs font-semibold">
                      {index + 1}
                    </span>
                  </span>
                  <span className="text-sm text-gray-700">{error}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Suggested Actions */}
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Hva kan du gjøre?</h4>
            <ul className="text-sm text-gray-600 space-y-1 mb-4">
              <li>• Sjekk internettforbindelsen din</li>
              <li>• Prøv å oppdatere siden</li>
              <li>• Kontakt support hvis problemet vedvarer</li>
            </ul>
            
            {/* Action Buttons */}
            <div className="flex flex-wrap gap-3 mt-4">
              <button
                onClick={handleRetry}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
              >
                <ArrowPathIcon className="h-4 w-4 mr-2" />
                {retryLabel || "Prøv igjen"}
              </button>
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
              >
                Gå tilbake
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
